
import React from 'react';

export const AboutSection: React.FC = () => {
  const stats = [
    { number: '500+', label: '완료 프로젝트' },
    { number: '50+', label: '파트너 기업' },
    { number: '15년', label: '업계 경험' },
    { number: '99.9%', label: '시스템 안정성' }
  ];

  const team = [
    {
      name: '김철수',
      position: '대표이사 / CTO',
      description: '건설 자동화 분야 15년 경력, 서울대 토목공학 박사',
      image: 'https://public.readdy.ai/ai/img_res/37d5599b4a14f122ed88bc2c909b6626.jpg'
    },
    {
      name: '이영희',
      position: '기술이사 / AI 연구소장',
      description: 'AI 및 빅데이터 전문가, KAIST 컴퓨터공학 박사',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20female%20engineer%20in%20business%20attire%2C%20AI%20technology%20expert%2C%20confident%20pose%2C%20modern%20office%20background%2C%20professional%20headshot%2C%20blue%20and%20white%20color%20scheme%2C%20tech%20industry%20professional&width=400&height=400&seq=cto-profile&orientation=squarish'
    },
    {
      name: '박민수',
      position: '영업이사',
      description: '건설업계 네트워크 전문가, 고려대 경영학 석사',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20male%20sales%20director%20in%20business%20suit%2C%20construction%20industry%20sales%20expert%2C%20confident%20pose%2C%20office%20background%2C%20professional%20headshot%2C%20blue%20and%20white%20color%20scheme%2C%20business%20professional&width=400&height=400&seq=sales-profile&orientation=squarish'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            회사 소개
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            건설 현장의 안전과 효율성을 위해 끊임없이 혁신하는 기술 기업입니다
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">
                {stat.number}
              </div>
              <div className="text-gray-600">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-800 mb-6">
                우리의 비전
              </h3>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                SmartConstruct는 2009년 설립 이래 건설 현장의 디지털 혁신을 선도해왔습니다. 
                우리는 첨단 IoT 기술과 AI 분석을 통해 건설 현장의 안전성과 효율성을 극대화하는 
                통합자동화 계측 솔루션을 제공합니다.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                전국 500여 개 프로젝트에서 검증된 기술력과 50여 개 파트너 기업과의 
                협력을 바탕으로 건설업계의 스마트 전환을 이끌어가고 있습니다.
              </p>
            </div>
            <div 
              className="h-96 bg-cover bg-center rounded-lg shadow-lg"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20office%20building%20with%20SmartConstruct%20company%2C%20professional%20corporate%20headquarters%2C%20glass%20facade%2C%20blue%20and%20white%20corporate%20colors%2C%20clean%20architectural%20design%2C%20business%20district%20location%2C%20contemporary%20office%20building&width=600&height=600&seq=company-building&orientation=squarish')`
              }}
            ></div>
          </div>
        </div>
        
        <div>
          <h3 className="text-3xl font-bold text-gray-800 text-center mb-12">
            핵심 인재
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {team.map((member, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden text-center">
                <div 
                  className="h-64 bg-cover bg-center"
                  style={{ backgroundImage: `url(${member.image})` }}
                ></div>
                <div className="p-6">
                  <h4 className="text-xl font-semibold text-gray-800 mb-2">
                    {member.name}
                  </h4>
                  <p className="text-blue-600 font-medium mb-3">
                    {member.position}
                  </p>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {member.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
